import React, { useState, useEffect } from 'react';
import AssetHistoryPage from './AssetHistory.styles';
import IntlMessages from '@iso/components/utility/intlMessages';
import { Button, Dropdown, Menu, Popconfirm, Timeline, Card, Row, Col } from 'antd';
import { PlusOutlined, DownOutlined, EditOutlined, DeleteOutlined,PlusCircleOutlined, CloseOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import { activityService, propertyService } from '@iso/services';
import _ from 'lodash';
import moment from 'moment';
import { commonHelper } from '@iso/lib/helpers/commonHelper';
import { objectColors } from '@iso/constants/objectColors';
import EditHistoryModal from '@iso/containers/Pages/PropertyMap/components/Mob/EditHistoryModal';
import EditLockOutHistoryModal from './EditLockOutHistoryModal';

const AssetHistory = (props) => {
  const activePropertyId = useSelector((state) => state.property.activePropertyId);
  const activePermission = useSelector((state) => state.permission.activePermission);
  const currentUser = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const [assetHistoryData, setAssetHistoryData] = useState([]);
  const [visibleEditHistoryModal, setVisibleEditHistoryModal] = useState(false);
  const [visibleEditLockOutModal, setVisibleEditLockOutModal] = useState(false);
  const [historyData, setHistoryData] = useState({});

  useEffect(() => {
    setAssetHistoryData(props.assetHistory);
  }, [props.assetHistory]);

  // Check if current user can edit a specific lockout history record
  const canEditLockOutHistory = (lockOutData) => {
    if (!currentUser || !lockOutData) {
      return false;
    }
    // User can edit if they created the lockout or are the assigned manager
    return currentUser.id === lockOutData.user_id || currentUser.id === lockOutData.manager_id;
  };

  const renderDeleteHistoryButton = (history) => {
    const isLockOut = history.metadata && history.metadata.lock_out;
    let canDelete = false;
    
    if (isLockOut) {
      // For lockout records, check specific user authorization
      canDelete = canEditLockOutHistory(history.metadata.lock_out);
    } else {
      // For other records, use general permission check
      canDelete = activePermission == "owner" || activePermission == "admin" || activePermission == "modify";
    }
    
    return (
        canDelete && <Popconfirm
          placement="bottomRight"
          title="You are about to delete individual record"
          onConfirm={() => {
            confirmDelete(history);
          }}
          okText="Yes"
          cancelText="No"
          className="delete-button"
        >
        <a style={{color:'red', marginRight: '20px', float:'right'}}>
          {<CloseOutlined />}
        </a>
        </Popconfirm>
      )
  }

  const renderEditHistoryButton = (history) => {
    const isLockOut = history.metadata && history.metadata.lock_out;
    let canEdit = false;
    
    if (isLockOut) {
      // For lockout records, check specific user authorization
      canEdit = canEditLockOutHistory(history.metadata.lock_out);
    } else {
      // For other records, use general permission check
      canEdit = activePermission == "owner" || activePermission == "admin" || activePermission == "modify";
    }
    
    return (
      canEdit &&
      <a style={{color:'#0B2A1B', marginRight: '20px', float:'right'}} 
         onClick={() => isLockOut ? showEditLockOutModal(history) : showEditHistoryModal(history)}>
        {<EditOutlined />}
      </a>
    )
  }

  const showEditHistoryModal = (history_data) => {
    setHistoryData(history_data);
    setVisibleEditHistoryModal(true);
  }

  const showEditLockOutModal = (history_data) => {
    setHistoryData(history_data);
    setVisibleEditLockOutModal(true);
  }

  const cancelEditHistoryModal = () => {
    setHistoryData({});
    setVisibleEditHistoryModal(false);
  }

  const cancelEditLockOutModal = () => {
    setHistoryData({});
    setVisibleEditLockOutModal(false);
  }

  const confirmDelete = (del_history) => {
    if(del_history.id){
       activityService.destroy(del_history.id).then(res => {
        if(res.code === '0000'){
          props.updateDataAssetHistory(props.dataId, 'facilities');
        }
      });
    }

  }

  // Helper function to get color label from color value
  const getColorLabel = (colorValue) => {
    if (!colorValue) return '';
    const colorObj = objectColors.find(color => color.value === colorValue);
    return colorObj ? colorObj.label : colorValue;
  };

  // Helper function to format UTC datetime to local
  const formatDate = (dateString) => {
    if (!dateString) return '';
    return commonHelper.convertUtcToLocalDate(dateString, 'll');
  };

  const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) return '';
    return commonHelper.convertUtcToLocalDate(dateTimeString, 'lll');
  };

  return (
    <AssetHistoryPage>
      <div style={{ overflow: "scroll", width: "100%", height: "600px" }}>
      <br/>
        <Timeline>
         {(assetHistoryData) ? (assetHistoryData.map((value, index) => {
          // Universal change log: field edits recorded by ActivityLogBehavior.
          if(value.metadata && value.metadata.type === 'update'){
            const changes = value.metadata.changes || [];
            return (
            <Timeline.Item color="blue" key={index}>
              <p>{moment(value.created_at).format('lll')}</p>
              <Card title='Details Updated' bordered={true}>
                {changes.length ? changes.map((c, i) => (
                  <Row key={i}>
                    <Col xs={{span: 11}} md={{span: 11}}>
                      <p className="card_content">{c.label || c.field}</p>
                    </Col>
                    <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                      <b className="card_value">{`${c.from === null || c.from === undefined || c.from === '' ? '—' : c.from} → ${c.to === null || c.to === undefined || c.to === '' ? '—' : c.to}`}</b>
                    </Col>
                  </Row>
                )) : <p className="card_content">Record updated</p>}
                {value.user && (
                  <Row>
                    <Col xs={{span: 11}} md={{span: 11}}><p className="card_content">By</p></Col>
                    <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}><b className="card_value">{value.user.name}</b></Col>
                  </Row>
                )}
              </Card>
            </Timeline.Item>
            );
          }
          // Universal change log: attachment add / remove.
          if(value.metadata && value.metadata.type === 'attachment'){
            const added = value.metadata.action === 'attachment_added';
            return (
            <Timeline.Item color={added ? 'cyan' : 'red'} key={index}>
              <p>{moment(value.created_at).format('lll')}</p>
              <Card title={added ? 'Attachment Added' : 'Attachment Removed'} bordered={true}>
                <Row>
                  <Col xs={{span: 11}} md={{span: 11}}><p className="card_content">File</p></Col>
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}><b className="card_value">{value.metadata.filename || '—'}</b></Col>
                </Row>
                {value.user && (
                  <Row>
                    <Col xs={{span: 11}} md={{span: 11}}><p className="card_content">By</p></Col>
                    <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}><b className="card_value">{value.user.name}</b></Col>
                  </Row>
                )}
              </Card>
            </Timeline.Item>
            );
          }
          if(value.metadata && value.metadata.usage){
            return (
            <Timeline.Item color="green" key={index}>
              {renderDeleteHistoryButton(value)}
              {renderEditHistoryButton(value)}
              <p>{moment(value.created_at).format('ll')}</p>
              <Card title='Usage' bordered={true}>
                <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Type</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.usage.type}</b>
                  </Col>
                </Row>
                {(value.metadata.usage.type === 'Hours') && <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Total Hours</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.usage.total_hours}</b>
                  </Col>
                </Row>}
                {(value.metadata.usage.type === 'Volume') && <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Total Volume</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.usage.total_volume}</b>
                  </Col>
                </Row>}
                {(value.metadata.usage.type === 'Other') && <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Other Type</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.usage.other_type}</b>
                  </Col>
                </Row>}
                <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Date</p> 
                  </Col>
                    
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                  <b className="card_value">{moment(value.metadata.usage.date).format('ll')}</b>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Location</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.usage.location}</b>
                  </Col>
                </Row>
                {(value.metadata.usage.description) && <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Description</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.usage.description}</b>
                  </Col>
                </Row>}
              </Card>
            </Timeline.Item>
            );
          }

          if(value.metadata.service){
            return (
            <Timeline.Item color="green" key={index}>
              {renderDeleteHistoryButton(value)}
              {renderEditHistoryButton(value)}
              <p>{moment(value.created_at).format('ll')}</p>
              <Card title='Service' bordered={true}>
                <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Type</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.service.type}</b>
                  </Col>
                </Row>
                {(value.metadata.service.type === 'Hours') && <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Total Hours</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.service.total_hours}</b>
                  </Col>
                </Row>}
                {(value.metadata.service.type === 'Volume') && <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Total Volume</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.service.total_volume}</b>
                  </Col>
                </Row>}
                {(value.metadata.service.type === 'Other') && <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Other Type</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.service.other_type}</b>
                  </Col>
                </Row>}
                <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Date</p> 
                  </Col>
                    
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                  <b className="card_value">{moment(value.metadata.service.date).format('ll')}</b>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Location</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.service.location}</b>
                  </Col>
                </Row>
                {(value.metadata.service.description) && <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Description</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.service.description}</b>
                  </Col>
                </Row>}
              </Card>
            </Timeline.Item>
            );
          }

          if(value.metadata.refill){
            return (
            <Timeline.Item color="green" key={index}>
              {renderDeleteHistoryButton(value)}
              {renderEditHistoryButton(value)}
              <p>{moment(value.created_at).format('ll')}</p>
              <Card title='Refill' bordered={true}>
                <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Type</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.refill.type}</b>
                  </Col>
                </Row>
                {(value.metadata.refill.type === 'Hours') && <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Total Hours</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.refill.total_hours}</b>
                  </Col>
                </Row>}
                {(value.metadata.refill.type === 'Volume') && <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Total Volume</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.refill.total_volume}</b>
                  </Col>
                </Row>}
                {(value.metadata.refill.type === 'Other') && <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Other Type</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.refill.other_type}</b>
                  </Col>
                </Row>}
                <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Date</p> 
                  </Col>
                    
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                  <b className="card_value">{moment(value.metadata.refill.date).format('ll')}</b>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Location</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.refill.location}</b>
                  </Col>
                </Row>
                {(value.metadata.refill.description) && <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Description</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.refill.description}</b>
                  </Col>
                </Row>}
              </Card>
            </Timeline.Item>
            );
          }

          if(value.metadata.other){
            return (
            <Timeline.Item color="green" key={index}>
              {renderDeleteHistoryButton(value)}
              {renderEditHistoryButton(value)}
              <p>{moment(value.created_at).format('ll')}</p>
              <Card title={value.metadata.other.other_category} bordered={true}>
                <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Type</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.other.type}</b>
                  </Col>
                </Row>
                {(value.metadata.other.type === 'Hours') && <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Total Hours</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.other.total_hours}</b>
                  </Col>
                </Row>}
                {(value.metadata.other.type === 'Volume') && <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Total Volume</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.other.total_volume}</b>
                  </Col>
                </Row>}
                {(value.metadata.other.type === 'Other') && <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Other Type</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.other.other_type}</b>
                  </Col>
                </Row>}
                <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Date</p> 
                  </Col>
                    
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                  <b className="card_value">{moment(value.metadata.other.date).format('ll')}</b>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Location</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.other.location}</b>
                  </Col>
                </Row>
                {(value.metadata.other.description) && <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Description</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.other.description}</b>
                  </Col>
                </Row>}
              </Card>
            </Timeline.Item>
            );
          }

          // Lock Out History Display
          if(value.metadata.lock_out){
            const isUnlocked = value.metadata.lock_out.status === 'unlocked';
            const timelineColor = isUnlocked ? 'green' : 'red';

            return (
            <Timeline.Item color={timelineColor} key={index}>
              {renderDeleteHistoryButton(value)}
              {renderEditHistoryButton(value)}
              <p>{moment(value.created_at).format('ll')}</p>
              <Card title='Lock Out' bordered={true}>
                {isUnlocked && value.metadata.lock_out.unlock_datetime && (
                  <>
                    <Row>
                      <Col xs={{span: 11}} md={{span: 11}}>
                        <p className="card_content">Status</p>
                      </Col>

                      <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                       <b className="card_value" style={{color: 'green'}}>Lock Removed</b>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={{span: 11}} md={{span: 11}}>
                        <p className="card_content">Unlock Date & Time</p>
                      </Col>

                      <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                       <b className="card_value">{moment(value.metadata.lock_out.unlock_datetime).format('YYYY-MM-DD HH:mm')}</b>
                      </Col>
                    </Row>
                    {value.metadata.lock_out.unlock_reason && (
                      <Row>
                        <Col xs={{span: 11}} md={{span: 11}}>
                          <p className="card_content">Unlock Reason</p>
                        </Col>

                        <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                         <b className="card_value">{value.metadata.lock_out.unlock_reason}</b>
                        </Col>
                      </Row>
                    )}
                  </>
                )}
                <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Date & Time</p>
                  </Col>

                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{moment(value.metadata.lock_out.datetime).format('YYYY-MM-DD HH:mm')}</b>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Expiry Date & Time</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{moment(value.metadata.lock_out.expiry_datetime).format('YYYY-MM-DD HH:mm')}</b>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Reason</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.lock_out.reason}</b>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Location</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.lock_out.location_name || value.metadata.lock_out.location || 'N/A'}</b>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">User</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.lock_out.user_name || 'N/A'}</b>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Contact Number</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.lock_out.contact_number}</b>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Lock Number</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.lock_out.lock_number}</b>
                  </Col>
                </Row>
                {(value.metadata.lock_out.lock_colour) && <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Lock Color</p>
                  </Col>

                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{getColorLabel(value.metadata.lock_out.lock_colour)}</b>
                  </Col>
                </Row>}
                <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Alarm (minutes before expiry)</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.lock_out.alarm_minutes || 30}</b>
                  </Col>
                </Row>
                {(value.metadata.lock_out.manager_name) && <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Manager</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.lock_out.manager_name}</b>
                  </Col>
                </Row>}
                {(value.metadata.lock_out.description) && <Row>
                  <Col xs={{span: 11}} md={{span: 11}}>
                    <p className="card_content">Description</p> 
                  </Col>
                   
                  <Col xs={{span: 11, offset: 2}} md={{span: 11, offset: 2}}>
                   <b className="card_value">{value.metadata.lock_out.description}</b>
                  </Col>
                </Row>}
                {(value.attachments && value.attachments.length > 0) && <Row>
                  <Col xs={{span: 24}}>
                    <p className="card_content">Attachments</p>
                    <div style={{ marginTop: '10px' }}>
                      {value.attachments.map((attachment, idx) => (
                        <div key={idx} style={{ marginBottom: '5px' }}>
                          <a 
                            href={attachment.full_path} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{ color: '#1890ff' }}
                          >
                            {attachment.url ? attachment.url.split('/').pop() : `Attachment ${idx + 1}`}
                          </a>
                        </div>
                      ))}
                    </div>
                  </Col>
                </Row>}
              </Card>
            </Timeline.Item>
            );
          }
        })) : ''}
        </Timeline>
      </div>
      <EditHistoryModal visibleEditHistoryModal={visibleEditHistoryModal} cancelEditHistoryModal={cancelEditHistoryModal}
        historyData={historyData} updateDataHistory={props.updateDataAssetHistory} dataType="facilities"
      />
      <EditLockOutHistoryModal 
        visible={visibleEditLockOutModal} 
        onCancel={cancelEditLockOutModal}
        historyData={historyData} 
        onUpdate={props.updateDataAssetHistory}
        onAssetUpdated={props.onAssetUpdated}
        updatePropertyDetail={props.updatePropertyDetail}
      />
    </AssetHistoryPage>
  )
}

export default AssetHistory;